import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import { resetChunkReloadFlag } from "./utils/chunkReload.js";
import "./index.css";

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Booted past any stale-chunk reload → the app is healthy again. Clear the flag
// so a *future* deploy can still auto-recover once (see ChunkErrorBoundary).
resetChunkReloadFlag();

// PWA worker. Production only and never on localhost, so `vite preview`/dev
// smoke tests always talk to a fresh build instead of a cached shell.
if (
  import.meta.env.PROD &&
  "serviceWorker" in navigator &&
  !["localhost", "127.0.0.1", "::1"].includes(window.location.hostname)
) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("sw.js").catch(() => {
      // Host may not serve it — the app is fine without the worker.
    });
  });
}
